export default __webpack_public_path__ + "static/media/ascending-bars.341d0ed6.svg";